<template>
  <div id="ok-modal">
    <div class="modal-main-content">
      <p v-html="text"></p>
    </div>
    <div>
      <button @click="$emit('close')" :class="modalClass">OK</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "okModal",
    props: ['text', 'modalClass']
  }
</script>

<style scoped>
  .modal-main-content {
    font-family: "Bitstream Charter";
    color: gray;
    padding: 15px;
    text-align: center;
  }

  .modal-ok-button{
    margin: 1%;
    width: 98%;
  }
</style>
